export default {"src":"/_next/static/media/b5.fab1985f.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};